// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const v1LinkedWorkItemSchema = z.object({
  id: z.coerce.string().describe("Identifier of the work item in the external tool (e.g., LIN-123)").nullish(),
  title: z.coerce.string().describe("Title of the linked work item").nullish(),
  sync_status: z.coerce.string().describe("Sync status: pending, synced, failed, or auth_required").nullish(),
});
